import {slotIn} from './refreshScheduleData';
import {dateDisplay, defaultEnableCal} from './dateDisplay';
import { highLightSlot } from './hms/os-flow';
export const schedulerState = {
    profileObj: {} as any,
    dateStart: '' as any,
    page: 0,
    numberOfSlot: 1,
    incr: 1,
    decr: 0,
    selectedDate: undefined as any,
    postalCode: "",
}
var selectedDate:any;

$('.calendar-wrapper .next-btn').click(function(){
    // highLightSlot();
    if (window.objOSGlobal.requestBodyValues.ConceptId == '25'){
        defaultEnableCal.enable= true;
        defaultEnableCal.changeActive = false;
    }
    $('.calendar-wrapper .prev-btn').removeClass('hidden');
    slotIn.slotIndex = slotIn.slotIndex + 5;
    dateDisplay(slotIn.slotIndex);
});
$('.calendar-wrapper .prev-btn').click(function(){
    // slotIn.slotIndex = Math.max(slotIn.slotIndex - 5, 0)
    // dateDisplay(Math.max(slotIn.slotIndex));
    // highLightSlot();
    if (window.objOSGlobal.requestBodyValues.ConceptId == '25'){
        defaultEnableCal.enable = true;
        defaultEnableCal.changeActive = false;
    }
    slotIn.slotIndex = Math.max(slotIn.slotIndex - 5, 0)
    if(Math.max(slotIn.slotIndex) == 0){
        dateDisplay(Math.max(slotIn.slotIndex));
        if (window.objOSGlobal.requestBodyValues.ConceptId == '25'){
            $('.calendar-wrapper .prev-btn').addClass('hidden');
        }
        
    }else{
        if (window.objOSGlobal.requestBodyValues.ConceptId == '25'){
            $('.calendar-wrapper .next-btn').removeClass('hidden');
        }
        dateDisplay(Math.max(slotIn.slotIndex));
    }
});

$(".calendar-row").on("click", ".calendar-btn", function (){
    $('.calendar-btn').removeClass('active-cal');
    if ($(this).hasClass('disabled')){
        return;
    }
    var displayText = $(this).attr('data-time');
    // var schduleId = $(this).attr('data-scheduleid');
    selectedDate = $(this).attr('data-selectedDate');
    window.objOSGlobal.requestBodyValues.selectedDate = $(this).attr('data-selectedDate');
    window.objOSGlobal.requestBodyValues.ScheduleId = $(this).attr('data-scheduleid');
    $(this).addClass('active-cal');
    var Preferredtime = $('.active-cal').html();
    sessionStorage.setItem('CTime', Preferredtime);
    $('.selected-date-txt').text(displayText);
    sessionStorage.setItem('selected-calendar-date', displayText);
    $('.date-details.selected-date').removeClass('hidden');
    $('#calendar-screen .next').removeClass('disble-btn').prop('disabled', false);
});

// $(".date-details-wrapper").on("click", ".date-details", function(e){
//     e.preventDefault();
//     var datesIndexId = $(this).attr("data-index");
//     if (window.innerWidth < 767) {        
//         $('.calendar-col').hide();
//         $('#'+datesIndexId).show();
//     }
//     else{
//         $('.calendar-col').show();
//     }
// });

$("#hms-online-shceduler-slide .date-details-wrapper").on("click", ".date-details", function (this: any)
{
    // nextBtnDisableFun();
    $('.date-details-wrapper .date-details').removeClass('active');
    $(this).addClass('active');
    var datesIndexId = $(this).attr("data-index");
    $('.calendar-col').hide();
    $('#hms-online-shceduler-slide #' + datesIndexId).show();
});

$("#dvw-online-shceduler-slide .date-details-wrapper").on("click", ".date-details", function (this: any)
{
    // nextBtnDisableFun();
    $('.date-details-wrapper .date-details').removeClass('active');
    $(this).addClass('active');
    var datesIndexId = $(this).attr("data-index");
    $('.calendar-col').hide();
    $('#dvw-online-shceduler-slide #' + datesIndexId).show();
});